export const BASIC_INFO = "BASIC_INFO_SAVE";
export const SPECIALTIES_AND_EDUCATION = "SPECIALTIES_AND_EDUCATION_SAVE";
export const WORK_EXPERIENCE = "WORK_EXPERIENCE_SAVE";
export const SKILLS_CHECKLIST = "SKILLS_CHECKLIST_SAVE";
export const REFERENCES = "REFERENCES_SAVE";
